import {DEVICE_TYPE} from "./constants.ts";

const NumberHelper = {}

const StringHelper = {
    getFileNameFromUrl(url?: string | null) {
        if (!url) return null;
        const pathParts = url.split('/');
        if (pathParts && pathParts.length > 0) {
            const lastPart = String(pathParts[pathParts.length - 1]);
            const firstUnderscore = lastPart.indexOf("_", 1);
            return lastPart.slice(firstUnderscore + 1, lastPart.length)
        }
        return null;
    },
    toSnakeCase(str: string): string {
        return str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
    },
    generateRandomString(length: number): string {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';

        for (let i = 0; i < length; i++) {
            const randomIndex = Math.floor(Math.random() * characters.length);
            result += characters[randomIndex];
        }

        return result;
    }
}

const DateHelper = {
    convertDateToStringDate(value: Date) {
        const date: Date = new Date(value);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}/${month}/${day}`;
    },
    convertDateToStringDateTime(value: Date) {
        const date: Date = new Date(value);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hour = String(date.getHours()).padStart(2, '0');
        const minute = String(date.getMinutes()).padStart(2, '0');

        return `${year}/${month}/${day} ${hour}:${minute}`;
    },
    timeDifferenceFromNow(date: Date): string {
        const now = new Date();
        const fromDate = new Date(date);
        const diffInMs = now.getTime() - fromDate.getTime();

        const diffInSeconds = Math.floor(diffInMs / 1000);
        const diffInMinutes = Math.floor(diffInSeconds / 60);
        const diffInHours = Math.floor(diffInMinutes / 60);
        const diffInDays = Math.floor(diffInHours / 24);

        if (diffInDays > 0) {
            return `${diffInDays} day(s)`;
        } else if (diffInHours > 0) {
            return `${diffInHours} hr(s)`;
        } else if (diffInMinutes > 0) {
            return `${diffInMinutes} min(s)`;
        } else {
            return `${diffInSeconds} s`;
        }
    },
}

const FunctionHelper = {
    getDeviceType() {
        const ua = navigator.userAgent;
        if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
            return DEVICE_TYPE.TABLET;
        }
        if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
            return DEVICE_TYPE.MOBILE;
        }
        return DEVICE_TYPE.DESKTOP;
    }
}

export {
    NumberHelper,
    DateHelper,
    StringHelper,
    FunctionHelper
};